import React, { useState, useEffect } from 'react';
import { Users, Activity, CheckCircle, ShoppingCart, Clock, RefreshCw, Store } from 'lucide-react';

function WorkerActivityTab({ token, API_BASE, activeShopId }) {
  const [workers, setWorkers] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchWorkerActivity = async () => {
    if (!token) return;
    setLoading(true);
    try {
      const shopParam = activeShopId ? `?shopId=${activeShopId}` : "";
      const res = await fetch(`${API_BASE}/worker-activity${shopParam}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (Array.isArray(data)) setWorkers(data);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => {
    fetchWorkerActivity();
    const interval = setInterval(fetchWorkerActivity, 15000); // Live refresh every 15s
    return () => clearInterval(interval);
  }, [token, activeShopId]);

  return (
    <div className="space-y-8">
      <div className="bg-slate-900 rounded-[45px] p-8 border border-blue-500/10 shadow-2xl flex flex-col sm:flex-row justify-between items-start sm:items-center gap-6">
        <div>
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 bg-blue-600/20 text-blue-400 rounded-2xl flex items-center justify-center border border-blue-500/30">
              <Users size={24} />
            </div>
            <div>
              <h3 className="text-2xl font-black text-white">Xodimlar Skanerlash Faoliyati</h3>
              <p className="text-slate-400 text-xs font-bold mt-1">Bugungi kunda har bir xodim/kassir tomonidan bajarilgan skanerlash faoliyati</p>
            </div>
          </div>
        </div>
        <button
          onClick={fetchWorkerActivity}
          disabled={loading}
          className="bg-blue-600 text-white px-6 py-4 rounded-[25px] font-black flex items-center gap-2 hover:bg-blue-700 transition shadow-[0_0_20px_rgba(37,99,235,0.3)] text-xs tracking-wider"
        >
          <RefreshCw size={18} className={loading ? 'animate-spin' : ''} /> YANGILASH
        </button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {workers.map((w, idx) => (
          <div key={idx} className="bg-slate-900 rounded-[35px] p-8 border border-white/5 hover:border-blue-500/30 transition-all shadow-xl space-y-6">
            <div className="flex justify-between items-center">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-gradient-to-br from-indigo-500 to-blue-600 text-white font-black rounded-xl flex items-center justify-center text-sm shadow-md">
                  #{idx + 1}
                </div>
                <div>
                  <h4 className="text-base font-black text-white truncate max-w-[160px]">{w.worker_email}</h4>
                  <p className="text-[10px] font-bold text-blue-400 uppercase tracking-widest flex items-center gap-1 mt-0.5">
                    <Store size={12} /> {w.branch_name}
                  </p>
                </div>
              </div>
              <span className="text-[10px] font-black uppercase tracking-widest px-3 py-1 bg-slate-800 text-slate-400 rounded-full border border-white/5">
                {w.worker_role || 'Xodim'}
              </span>
            </div>

            <div className="bg-slate-950 p-6 rounded-[25px] border border-white/5 flex items-center justify-between">
              <div>
                <p className="text-[10px] font-black text-slate-500 uppercase tracking-widest">Bugun Skaner Qildi</p>
                <p className="text-3xl font-black text-white mt-1">{w.total_scans_today} <span className="text-xs text-blue-400 font-bold">dona</span></p>
              </div>
              <div className="w-12 h-12 bg-emerald-500/10 text-emerald-400 rounded-2xl flex items-center justify-center border border-emerald-500/20">
                <Activity size={24} />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-3 text-xs">
              <div className="p-4 bg-slate-950/60 rounded-2xl border border-white/5">
                <p className="text-[9px] font-black text-slate-500 uppercase tracking-widest flex items-center gap-1 mb-1">
                  <CheckCircle size={12} className="text-emerald-400" /> Tekshirish
                </p>
                <p className="text-base font-black text-emerald-400">{w.check_scans_today} ta</p>
              </div>
              <div className="p-4 bg-slate-950/60 rounded-2xl border border-white/5">
                <p className="text-[9px] font-black text-slate-500 uppercase tracking-widest flex items-center gap-1 mb-1">
                  <ShoppingCart size={12} className="text-blue-400" /> Sotuv
                </p>
                <p className="text-base font-black text-blue-400">{w.sale_scans_today} ta</p>
              </div>
            </div>

            {w.last_scan_time && (
              <div className="flex items-center gap-2 text-[10px] text-slate-500 font-bold pt-2 border-t border-white/5">
                <Clock size={12} /> So'nggi skaner: {new Date(w.last_scan_time).toLocaleTimeString()}
              </div>
            )}
          </div>
        ))}

        {workers.length === 0 && (
          <div className="col-span-full bg-slate-900 rounded-[35px] p-12 text-center text-slate-500 border border-white/5">
            Xodimlar va skanerlash faoliyati topilmadi.
          </div>
        )}
      </div>
    </div>
  );
}

export default WorkerActivityTab;
